/// <amd-module name="VSSUI/Components/ResponsiveViewport/index" />
export * from "./ResponsiveViewport";
export { IBreakPoint, IResponsiveViewport, IResponsiveViewportProps } from "./ResponsiveViewport.Props";
